import React from 'react';
import { media } from 'src/styles/designs';
import styled, { ThemeProvider } from 'styled-components';
import { fromTheme, redTheme } from 'src/styles/theme';
import { ProductsBannerImageMobile } from 'src/modules/products/components//ProductsBanner/ProductsBannerImageMobile';
import { ProductsBannerImageDesktop } from 'src/modules/products/components//ProductsBanner/ProductsBannerImageDesktop';
import { MediaDirect } from 'vendor/mods/media-breakpoints-fresnel/components/Media';
import { StickyMenu } from 'src/components/common/StickyMenu';
import { ProductCategoryCode } from 'src/models/pim';
import { StickyMenuSection } from 'src/components/common/StickyMenu/StickyMenuSection';
import { useRectMeasure } from 'src/hooks/useRectMeasure';

const Container = styled.div`
  position: relative;
  width: 100%;

  height: 360px;
  ${media.w.greaterThanOrEqual.desktop} {
    height: 327px;
  }
`;

const ImagesContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;

const Needle = styled.div`
  background-color: ${fromTheme((theme) => theme.text.palette.accent)};
  position: relative;
  clip-path: polygon(60px 0, 100% 0, 0 100%);
  clip-path: polygon(0 0, 40% 0, 100% 100%, 95% 100%);
  width: 73px;
  height: 100%;
  top: 0;
  right: 500px;
  z-index: 0;

  ${media.w.lessThan.desktop} {
    display: none;
  }
`;

const InnerContainer = styled.div`
  position: absolute;
  left: 28px;
  bottom: 54px;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  ${media.w.greaterThanOrEqual.desktop} {
    left: 0;
    height: 100%;
    width: 100%;
    bottom: 0;
    align-items: center;
  }
`;

const DesktopStickyMenu = styled(StickyMenu)`
  margin-top: 45px;
`;

const stickyMenuSections = [
  { id: ProductCategoryCode.Fillers, label: 'fillers' },
  { id: ProductCategoryCode.Devices, label: 'devices' },
  { id: ProductCategoryCode.Cosmeceuticals, label: 'cosmeceuticals' },
];

export const ProductsBanner = () => {
  const [bannerRef, height] = useRectMeasure();

  return (
    <>
      <ThemeProvider theme={redTheme}>
        <StickyMenuSection threshold={1} as={Container} id={null}>
          <MediaDirect lessThan="desktop">
            <StickyMenu tabs={stickyMenuSections} bannerHeight={height} />
          </MediaDirect>
          <ImagesContainer ref={bannerRef}>
            <ProductsBannerImageMobile />
            <ProductsBannerImageDesktop />
          </ImagesContainer>
          <InnerContainer>
            <Needle />
          </InnerContainer>
        </StickyMenuSection>
      </ThemeProvider>
      <MediaDirect greaterThanOrEqual="desktop">
        <DesktopStickyMenu tabs={stickyMenuSections} />
      </MediaDirect>
    </>
  );
};
